import { components } from "@certn/api/generated-schemas/client-portal";
import { createContext, useContext } from "react";

export type User = components["schemas"]["UserCreate"];

interface CreateUserContextType {
  user: User;
  setUser: (userData: User) => void;
  currentStep: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const initialUserValues: User = {
  customer_account: "",
  full_name: "",
  email: "",
  customer_groups: [],
  role: "",
  location_country: "",
  primary_reviewer: null,
  additional_notification_emails: [],
};

export const CreateUserContext = createContext<CreateUserContextType>({
  user: initialUserValues,
  setUser: (newState: User) => newState,
  currentStep: 0,
  goToNextStep: () => {},
  goToPrevStep: () => {},
});

export function useCreateUserContext() {
  return useContext(CreateUserContext);
}
